import qs from "qs";

export default function query(need) {
    const queries = qs.parse(window.location.search.substr(1))
    if (!need) return queries
    return queries[need]
}
